import { FC } from 'react'
import { ReCaptchaProvider } from 'next-recaptcha-v3'
import Page from '@/client/submodules/Page'
import { ContactForm } from './ContactForm'
import { Featured } from './Featured'
import { SampleBookProps } from './types'

export const SampleBook: FC<SampleBookProps> = ({
  seo,
  header,
  footer,
  content: {
    breadcrumb,
    long_text,
    heading,
    contact_form,
    language,
    result,
    assert_text,
    first_side_box,
    second_side_box
  }
}) => (
  <ReCaptchaProvider
    strategy='lazyOnload'
    defer
    async
    language='en'
    useEnterprise
    reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_KEY}
  >
    <Page seo={seo} header={header} footer={footer}>
      <Featured breadcrumb={breadcrumb} heading={heading} long_text={long_text} />
      <ContactForm
        contact_form={contact_form}
        language={language}
        result={result}
        assert_text={assert_text}
        first_side_box={first_side_box}
        second_side_box={second_side_box}
      />
    </Page>
  </ReCaptchaProvider>
)
